import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css'; 
import { logError, logInfo } from './utils/logger';
import { initializeDatabase } from './utils/database';

// Force direct console output for debugging
console.log('Application bootstrap starting...');

const root = document.getElementById('root');
if (!root) {
  console.error('Fatal: Root element not found');
  throw new Error('Root element not found');
}

// Show initial loading state
root.innerHTML = `
  <div class="min-h-screen bg-[#3D3F42] flex items-center justify-center p-4">
    <div class="flex flex-col items-center gap-4">
      <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-white"></div>
      <div class="text-white text-lg">Loading OverSizeHub...</div>
      <div class="text-gray-400 text-sm">Initializing application...</div>
    </div>
  </div>
`;

const initializeApp = async () => {
  try {
    console.log('Initializing database...');
    const dbInitialized = await initializeDatabase();
    if (!dbInitialized) {
      throw new Error('Database initialization failed');
    }
    console.log('Database initialized successfully');

    console.log('Rendering React application...');
    const reactRoot = createRoot(root);
    reactRoot.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
    console.log('React application rendered successfully');

  } catch (error) {
    console.error('Application initialization failed:', error);
    root.innerHTML = `
      <div class="min-h-screen bg-[#3D3F42] flex items-center justify-center p-4">
        <div class="bg-[#2A2B2E] p-6 rounded-lg text-center max-w-lg">
          <h2 class="text-xl font-semibold text-red-500 mb-2">Unable to Load Application</h2>
          <p class="text-gray-400 mb-4">${error.message || 'Please check your connection and try again.'}</p>
          <button 
            onclick="window.location.reload()"
            class="px-4 py-2 bg-gray-700 text-white rounded hover:bg-gray-600"
          >
            Retry
          </button>
        </div>
      </div>
    `;
  }
};

// Start initialization immediately
initializeApp().catch(error => {
  console.error('Fatal initialization error:', error);
});